(function () {
    'use strict';

    angular.module("imApp").factory("stockControlLocStockService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1707,
                    parameters: parms || {}
                });
            },
            listOthers: function (parms) {
                return $ihttp.post({
                    method: 1709,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1708,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
